import { ApiResponse } from '../../../types/Response'
import { DissectParserProps } from '../types/DissectParserTypes'
import { DissectedError, DissectedErrorGroups, LogType, exists, logError, tagMessage } from '../../..'

export const parseApiResponseExpectData = async <TApiResponse extends ApiResponse = ApiResponse>({
    responseBody,
    expectData,
    responseStatusText,
    responseStatus,
    caller,
}: DissectParserProps<TApiResponse>): Promise<void> => {
    let awaitedApiResponse: TApiResponse | null = null
    try {
        awaitedApiResponse = await responseBody
    } catch {}

    if (!awaitedApiResponse) {
        // handeling of no response body is done elsewhere
        return
    }
    if (!awaitedApiResponse.data && expectData && awaitedApiResponse.isSuccess) {
        logError('data not found while isSuccess is true', { logType: LogType.UNEXPECTED, caller })
        throw new DissectedError(tagMessage('data not found while isSuccess is true', caller), {
            statusCode: exists(awaitedApiResponse.errorCode) ? +awaitedApiResponse.errorCode : responseStatus,
            statusMessage: awaitedApiResponse.message ?? responseStatusText,
            callerAction: caller,
            verboseMessage: 'received no data from Gateway, when data was expected while isSuccess is true',
            errorGroup: DissectedErrorGroups.NO_DATA_WHEN_DATA_WAS_EXPECTED,
            apiResponse: awaitedApiResponse,
        })
    }
}
